/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />
/// <reference path="../filters/upperCaseFilter.ts" />

module Meevo.Components.Controls {

    export class MeevoMenuHide implements angular.IDirective {
        private window: angular.IWindowService;
        restrict = "A";



        constructor($window: ng.IWindowService) {
            this.window = $window;
        }

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            window = this.window;

            var current;
            current = window.pageYOffset;
            var ref;
            angular.element(window).on('resize', function () {
                scope.$apply(function () {
                    scope.scrolled = false;
                })
            });
            $("*").scroll(function () {
                
                if ($(window).width() < 960) {
                    
                    if ($(this).scrollTop() > 0) {
                        scope.scrolled = true;
                        if (ref > $(this).scrollTop()) {
                            //console.log("back scrolled");
                            scope.scrolled = false;
                        }
                        else
                            scope.scrolled = true;
                        ref = $(this).scrollTop();

                    } else {
                        scope.scrolled = $(this).scrollTop();
                        //console.log("at top");
                    }
                    current = window.pageYOffset;
                    return scope.$apply();
                }
                
            });

        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($window) => {
                return new MeevoMenuHide($window);
            };

            directive.$inject = ["$window"];
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoMenuHide", MeevoMenuHide.factory());
}